module.exports = __webpack_public_path__ + "img/1589881889.f6652a3d.jpg";